import { Box, Typography, ToggleButton, ToggleButtonGroup, IconButton, Tooltip, Button, useMediaQuery } from "@mui/material";
import { colors } from "../../../../theme/muiColors";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import ViewListIcon from "@mui/icons-material/ViewList";
import AddIcon from "@mui/icons-material/Add";

type ViewMode = "kanban" | "list";

interface FlowDoHeaderProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  onCreateTaskClick?: () => void;
  onCreateCategoryClick?: () => void;
  isPreviewMode?: boolean;
}

export const FlowDoHeader = ({ viewMode, onViewModeChange, onCreateTaskClick, onCreateCategoryClick, isPreviewMode = false }: FlowDoHeaderProps) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: "center",
        width: "fit-content",
        maxWidth: "80%",
      }}
    >


      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          // border: "1px solid var(--fx-surface-border, #E2E8F0)", Delete this later.
          width: "100%",
          // maxWidth: "90%",
          justifyContent: "space-between",
          // border: "1px solid green",
        }}
      >
        {/* {onCreateTaskClick && (
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button //This is the button that I have to modify
              onClick={onCreateTaskClick}
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                bgcolor: colors.orange[400],
                color: "#ffffff",
                "&:hover": {
                  bgcolor: colors.orange[500],
                },
                borderRadius: 10,
              }}
            >
              New Task
            </Button>
          </Box>
        )} */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 200,
            fontSize: "0.875rem",
            color: "var(--fx-surface-texttertiary, #94A3B8)",
            width: "fit-content",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            mb: { xs: 2, sm: 0 },
          }}
        >
          View Mode:
        </Typography>
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={(_, newMode) => {
            if (newMode !== null) {
              onViewModeChange(newMode);
            }
          }}
          size="small"
        >
          <ToggleButton value="kanban" disableRipple sx={{
            color: viewMode === "kanban" ? "var(--fx-surface-text, #0F172A)" : "var(--fx-surface-texttertiary, #94A3B8)",
          }}>
            <ViewKanbanIcon sx={{ mr: { xs: 0, sm: 1 } }} />

          </ToggleButton>
          <ToggleButton value="list" disableRipple sx={{
            color: viewMode === "list" ? "var(--fx-surface-text, #0F172A)" : "var(--fx-surface-texttertiary, #94A3B8)",
          }}>
            <ViewListIcon sx={{ mr: { xs: 0, sm: 1 } }} />

          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};
